import isArray from './is-array';
import isFunction from './is-function';
import groupBy from './group-by';
/**
 * å°æ°æ®åç»æ map
 * @param data
 * @param condition
 */
export default function groupToMap(data, condition) {
    if (!condition) {
        return {
            0: data,
        };
    }
    if (!isFunction(condition)) {
        // å¦ææ¯å­ç¬¦ä¸²ï¼åæç§ a*b é£æ ¼ææ°ç»
        var paramscondition_1 = isArray(condition) ? condition : condition.replace(/\s+/g, '').split('*');
        condition = function (row) {
            var unique = '_'; // é¿ååºç°æ°å­ä½ä¸ºKeyçæåµï¼ä¼è¿è¡æç§æ°å­çæåº
            // æ ¹æ®å­æ®µåè¡¨çå¼ï¼æ¼æ¥æ key
            for (var i = 0, l = paramscondition_1.length; i < l; i++) {
                unique += row[paramscondition_1[i]] && row[paramscondition_1[i]].toString();
            }
            return unique;
        };
    }
    return groupBy(data, condition);
}
//# sourceMappingURL=group-to-map.js.map